import Vue from 'vue'
import Vuex from 'vuex'
import * as ACTIONS from '../actions'
import * as MUTATIONS from '../mutations'
import API from '../../services/api'

Vue.use(Vuex)

export default {
	state: {
		hashtag: {
			sentiment: [],
			postId: null,
			categories: [],
		},
		image: {
			postId: null,
			ocr: [],
			face: [],
			labels: [],
		},
	},
	mutations: {
		[MUTATIONS.ANALYSIS.IMAGE_OCR](state, ocr) {
			state.image.ocr = ocr.annotations
		},
		[MUTATIONS.ANALYSIS.IMAGE_EXPRESSION](state, expression) {
			state.image.face = expression.annotations
		},
		[MUTATIONS.ANALYSIS.IMAGE_LABELS](state, labels) {
			state.image.labels = labels.annotations
		},

		[MUTATIONS.ANALYSIS.HASHTAG_CLASSIFY](state, { categories }) {
			state.hashtag.categories = categories
		},
		[MUTATIONS.ANALYSIS.HASHTAG_SENTIMENT](state, { sentiment }) {
			state.hashtag.sentiment = sentiment
		},

		[MUTATIONS.ANALYSIS.HASHTAG](state, hashtag) {
			state.hashtag = hashtag
		},

		[MUTATIONS.ANALYSIS.IMAGE](state, image) {
			state.image = image
		},
	},
	actions: {
		[ACTIONS.ANALYSIS.IMAGE_OCR]({ commit, dispatch, state }, { postId, src }) {
			return API.ANALYSIS.IMAGE_OCR(postId, src).then(res => {
				commit(MUTATIONS.ANALYSIS.IMAGE_OCR, res)
				return res
			})
		},
		[ACTIONS.ANALYSIS.IMAGE_EXPRESSION](
			{ commit, dispatch, state },
			{ postId, src },
		) {
			return API.ANALYSIS.IMAGE_EXPRESION(postId, src).then(res => {
				commit(MUTATIONS.ANALYSIS.IMAGE_EXPRESSION, res)
				return res
			})
		},
		[ACTIONS.ANALYSIS.IMAGE_LABELS](
			{ commit, dispatch, state },
			{ postId, src },
		) {
			return API.ANALYSIS.IMAGE_LABELS(postId, src).then(res => {
				commit(MUTATIONS.ANALYSIS.IMAGE_LABELS, res)
				return res
			})
		},
		[ACTIONS.ANALYSIS.HASHTAG_SENTIMENT]({ commit, dispatch, state }, postId) {
			return API.ANALYSIS.HASHTAG_SENTIMENT(postId)
				.then(res => {
					commit(MUTATIONS.ANALYSIS.HASHTAG_SENTIMENT, res)
					return res
				})
				.catch(err => {
					commit(MUTATIONS.ANALYSIS.HASHTAG_SENTIMENT, { sentiment: [] })
					return err
				})
		},
		[ACTIONS.ANALYSIS.HASHTAG_CLASSIFY]({ commit, dispatch, state }, postId) {
			return API.ANALYSIS.HASHTAG_CATEGORIES(postId)
		},
		[ACTIONS.ANALYSIS.HASHTAG_ENTITY]({ commit, dispatch, state }, postId) {
			return API.ANALYSIS.HASHTAG_ENTITY(postId)
				.then(res => {
					commit(MUTATIONS.ANALYSIS.HASHTAG_ENTITY, res)
					return res
				})
				.catch(err => {
					commit(MUTATIONS.ANALYSIS.HASHTAG_ENTITY, { categories: [] })
					return err
				})
		},

		[ACTIONS.ANALYSIS.IMAGE]({ commit, dispatch, state }, postId) {
			if (+postId === state.image.postId) {
				return state.image
			} else {
				return API.ANALYSIS.IMAGE(postId).then(res => {
					commit(MUTATIONS.ANALYSIS.IMAGE, res)
					return res
				})
			}
		},
		[ACTIONS.ANALYSIS.HASHTAG]({ commit, dispatch, state }, postId) {
			if (+postId === state.hashtag.postId) {
				return state.hashtag
			} else {
				return API.ANALYSIS.HASHTAG(postId).then(res => {
					commit(MUTATIONS.ANALYSIS.HASHTAG, res)
					return res
				})
			}
		},
	},

	getters: {
		getPostHashtagAnalysis: state => state.hashtag,
		getPostImageAnalysis: state => state.image,
	},
}
